import React, { useState } from 'react';
import { FaTimes, FaPhone, FaLine, FaEnvelope, FaMapMarkerAlt, FaFacebook } from 'react-icons/fa'; 
import './FloatingContact.css';

const FloatingContact = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMapOpen, setIsMapOpen] = useState(false); // 🟢 เพิ่ม State สำหรับเปิดปิดแผนที่

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // 🟢 1. สร้างฟังก์ชัน openMap ไว้ด้านบนก่อนเรียกใช้
  const openMap = (e) => {
    e.preventDefault(); // ป้องกันไม่ให้เปิดแท็บใหม่
    setIsMapOpen(true);
    setIsOpen(false);   // ปิดเมนูลอยเมื่อแผนที่ขึ้นมา
  };

  const menuItems = [
    { 
      id: 1, 
      label: 'แผนที่บริษัท', 
      icon: <FaMapMarkerAlt className="custom-float-icon" />, 
      color: '#00aeef', // สีหลัก
      link: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d944.6014592541595!2d98.9594083696149!3d18.735400868942563!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30da31004afe6169%3A0xd9e0ad6904e71de2!2sAscent%20Corporation%20co.%2C%20ltd!5e0!3m2!1sth!2sth!4v1775278384870!5m2!1sth!2sth',
      action: openMap 
    },
    { 
      id: 2, 
      label: 'แชทผ่าน Facebook', 
      icon: <FaFacebook className="custom-float-icon" />, 
      color: '#00aeef', // สีรอง
      link: 'https://www.facebook.com/p/ART-Medical-61576144820349/' 
    },
    { 
      id: 3, 
      label: 'แชทผ่าน LINE', 
      icon: <FaLine className="custom-float-icon" />, 
      color: '#00aeef', // สีฟ้าสว่าง
      link: 'https://line.me/ti/p/~@730aicdq' 
    },
    { 
      id: 4, 
      label: 'โทรศัพท์ติดต่อ', 
      icon: <FaPhone className="custom-float-icon" />, 
      color: '#00aeef', 
      link: 'tel:0906187997' 
    },
    { 
      id: 5, 
      label: 'ส่งอีเมล', 
      icon: <FaEnvelope className="custom-float-icon" />, 
      color: '#00aeef', 
      link: 'mailto:ascentcorp.info@gmail.com' 
    }
  ];

  return (
    <>
      {/* 🟢 2. เพิ่มหน้าต่าง Pop-up แผนที่ (Modal) */}
      {isMapOpen && (
        <div className="map-modal-overlay" onClick={() => setIsMapOpen(false)}>
          <div className="map-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="map-modal-header">
              <h3>แผนที่บริษัท</h3>
              <button onClick={() => setIsMapOpen(false)} className="close-map-btn">
                <FaTimes />
              </button>
            </div>
            <div className="map-modal-body">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d944.6014592541595!2d98.9594083696149!3d18.735400868942563!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30da31004afe6169%3A0xd9e0ad6904e71de2!2sAscent%20Corporation%20co.%2C%20ltd!5e0!3m2!1sth!2sth!4v1775278384870!5m2!1sth!2sth" 
                width="100%" 
                height="100%" 
                style={{ border: 0 }} 
                allowFullScreen="" 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
                title="Google Map"
              ></iframe>
            </div>
          </div>
        </div>
      )}

      {/* 🟢 3. ส่วนเมนูลอยเดิม */}
      <div className="floating-container">
        <div className={`floating-menu ${isOpen ? 'is-open' : ''}`}>
          {menuItems.map((item, index) => (
            <a 
              key={item.id} 
              href={item.link} 
              // ตรวจสอบว่าถ้ามี action (แผนที่) ให้ใช้ onClick แทนการเปิดลิงก์ปกติ
              onClick={item.action ? item.action : null}
              target={item.action ? "_self" : "_blank"} 
              rel="noopener noreferrer"
              className="floating-item"
              style={{ transitionDelay: `${(menuItems.length - index) * 50}ms` }}
            >
              <span className="floating-label">{item.label}</span>
              <div className="floating-icon" style={{ backgroundColor: item.color }}>
                {item.icon}
              </div>
            </a>
          ))}
        </div>

        <button 
          className={`floating-main-btn ${isOpen ? 'is-open' : ''}`} 
          onClick={toggleMenu}
        >
          {isOpen ? (
            <FaTimes /> 
          ) : (
            <img src="/assets/Medical.png" alt="Contact" className="main-custom-icon" />
          )}
        </button>
      </div>
    </>
  );
};

export default FloatingContact;